import ResponseErrorHandling from "../../../../helper/ResponseErrorHandling";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes, ModulesActionTypes } from "../../../action-types";

export const getModuleStatus = (data) => async (dispatch, getState) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const currentUser = getState().user?.user;
    const isLoggedIn = currentUser && currentUser.token;

    const endpoint = isLoggedIn
      ? "/lookups/module-status"
      : "/lookups/sumsub-module-status";

    // Normalize payload to ensure `{ modules: [...] }` format
    const payload = Array.isArray(data)
      ? { modules: data }
      : Array.isArray(data?.modules)
      ? data
      : data;

    const res = await commonService.post(endpoint, payload);

    // Backend returns keyed map: { moduleName: { status: boolean, module: "enabled"|"disabled" } }
    const modulesResponse = res.data?.data || {};
    let storedModules = JSON.parse(localStorage.getItem("modules")) || [];

    Object.entries(modulesResponse).forEach(([moduleName, details]) => {
      const itemData = { module: moduleName, status: details.status };
      const moduleIndex = storedModules.findIndex((mod) => mod.module === moduleName);

      if (moduleIndex !== -1) {
        storedModules[moduleIndex] = itemData;
      } else {
        storedModules.push(itemData);
      }
    });

    localStorage.setItem("modules", JSON.stringify(storedModules));

    // Update Redux state with the merged module list
    dispatch({
      type: ModulesActionTypes.UPDATE_MODULES,
      payload: storedModules,
    });

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || err.message || err.toString();

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
